export default {
  ID_ODS: '7db3be4f-cef7-4865-9756-4fba5ca9e22b',
  ID_AUE: '2d998395-888e-47b2-9f60-da331d814691',
  ID_IDDIGO: 'd8f8dcc8-5071-431f-97f1-0572b0e888c5',

  RESPUESTA_AFIRMATIVA: 'Sí',
  RESPUESTA_NEGATIVA: 'No',

  SUBTIPO_DEFECTO: 'DEFECTO',
  SUBTIPO_LIBRE: 'LIBRE',
  SUBTIPO_SUBIR_DECLARACION: 'SUBIR_DECLARACION',
  RESOLUTION_MOBILE: window.matchMedia('(max-width: 1042px)')
};
